<template>
  <OperationsDashboard mode="inventory" />
</template>
<script setup>
import OperationsDashboard from '@/components/module/smart/OperationsDashboard.vue';
</script>
